<template>
  <div>
    <search-bar  :backgroundColorGray="true" ></search-bar>

    <section>
      <div class="container">
        <h1 class="text-center text-md-left">Eventos</h1>
        <h2 class="title text-center text-md-left">Autopar 2014</h2>
        <!-- <p>Autopar foi um evento lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla interdum mauris ut arcu placerat condimentum. Suspendisse egestas auctor augue, nec faucibus arcu fermentum eget. Cras nisi urna, aliquam vitae pellentesque et, mollis in ex. Sed tristique dolor magna, sed vehicula felis viverra eu. Cras ac nunc ut orci ultricies aliquam. Ut dolor elit, viverra et bibendum sed, blandit eu tellus. Suspendisse dapibus magna et porta aliquet. Mauris orci erat, consequat a velit eget, scelerisque faucibus nulla.</p> -->

        <div class="row">
          <div class="col-md-3 mt-4 col-6">
            <img src="../../static/images/event1.png" alt>
          </div>
          <div class="col-md-3 mt-4 col-6">
            <img src="../../static/images/event2.png" alt>
          </div>
          <div class="col-md-3 mt-4 col-6">
            <img src="../../static/images/event3.png" alt>
          </div>
          <div class="col-md-3 mt-4 col-6">
            <img src="../../static/images/event4.png" alt>
          </div>
          <div class="col-md-3 mt-4 d-none d-md-block">
            <img src="../../static/images/event5.png" alt>
          </div>
          <div class="col-md-3 mt-4 d-none d-md-block">
            <img src="../../static/images/event6.png" alt>
          </div>
          <div class="col-md-3 mt-4 d-none d-md-block">
            <img src="../../static/images/event7.png" alt>
          </div>
          <div class="col-md-3 mt-4 d-none d-md-block">
            <img src="../../static/images/event8.png" alt>
          </div>
        </div>
      </div>
    </section>

    <section class="section-gray">
      <div class="container">
        <h2 class="title text-center text-md-left">Automec 2015</h2>
        <!-- <p>Automec foi um evento lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla interdum mauris ut arcu placerat condimentum. Suspendisse egestas auctor augue, nec faucibus arcu fermentum eget. Cras nisi urna, aliquam vitae pellentesque et, mollis in ex. Sed tristique dolor magna, sed vehicula felis viverra eu. Cras ac nunc ut orci ultricies aliquam. Ut dolor elit, viverra et bibendum sed, blandit eu tellus. Suspendisse dapibus magna et porta aliquet. Mauris orci erat, consequat a velit eget, scelerisque faucibus nulla.</p> -->

        <div class="row">
          <div class="col-md-3 mt-4 col-6">
            <img src="../../static/images/event9.png" alt>
          </div>
          <div class="col-md-3 mt-4 col-6">
            <img src="../../static/images/event10.png" alt>
          </div>
          <div class="col-md-3 mt-4 col-6">
            <img src="../../static/images/event11.png" alt>
          </div>
          <div class="col-md-3 mt-4 col-6">
            <img src="../../static/images/event12.png" alt>
          </div>
          <div class="col-md-3 mt-4 d-none d-md-block">
            <img src="../../static/images/event13.png" alt>
          </div>
          <div class="col-md-3 mt-4 d-none d-md-block">
            <img src="../../static/images/event14.png" alt>
          </div>
          <div class="col-md-3 mt-4 d-none d-md-block">
            <img src="../../static/images/event15.png" alt>
          </div>
          <div class="col-md-3 mt-4 d-none d-md-block">
            <img src="../../static/images/event16.png" alt>
          </div>
        </div>

        <!-- <div class="mt-5">
          <a href="#" class="btn btn-primary btn-block">Carregar mais</a>
        </div> -->
      </div>
    </section>

    <section>
      <div class="container">
        <h2 class="title text-center text-md-left">Automec 2017</h2>
        <!-- <p>Automec foi um evento lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla interdum mauris ut arcu placerat condimentum. Suspendisse egestas auctor augue, nec faucibus arcu fermentum eget. Cras nisi urna, aliquam vitae pellentesque et, mollis in ex. Sed tristique dolor magna, sed vehicula felis viverra eu. Cras ac nunc ut orci ultricies aliquam. Ut dolor elit, viverra et bibendum sed, blandit eu tellus. Suspendisse dapibus magna et porta aliquet. Mauris orci erat, consequat a velit eget, scelerisque faucibus nulla.</p> -->

        <div class="row">
          <div class="col-md-3 mt-4 col-6">
            <img src="../../static/images/event17.png" alt>
          </div>
          <div class="col-md-3 mt-4 col-6">
            <img src="../../static/images/event18.png" alt>
          </div>
          <div class="col-md-3 mt-4 col-6">
            <img src="../../static/images/event19.png" alt>
          </div>
          <div class="col-md-3 mt-4 col-6">
            <img src="../../static/images/event20.png" alt>
          </div>
          <div class="col-md-3 mt-4 d-none d-md-block">
            <img src="../../static/images/event21.png" alt>
          </div>
          <div class="col-md-3 mt-4 d-none d-md-block">
            <img src="../../static/images/event22.png" alt>
          </div>
          <div class="col-md-3 mt-4 d-none d-md-block">
            <img src="../../static/images/event23.png" alt>
          </div>
          <div class="col-md-3 mt-4 d-none d-md-block">
            <img src="../../static/images/event24.png" alt>
          </div>
        </div>

        <!-- <div class="mt-5">
          <a href="#" class="btn btn-primary btn-block">Carregar mais</a>
        </div> -->
      </div>
    </section>

    <div class="diagonal-line"></div>
  </div>
</template>

<script>
import EventsAPI from "@/api/events";

import SearchBar from "@/components/SearchBar.vue";

export default {
  data() {
    return {
      events: []
    };
  },
  mounted() {
    this.loadEvents();
  },
  components: { SearchBar },
  methods: {
    async loadEvents() {
      this.events = await EventsAPI.get();
      this.events.forEach(event => {});
    }
  }
};
</script>
<style lang="sass" scoped>

</style>




// WEBPACK FOOTER //
// src/pages/Events.vue